module.exports = __webpack_public_path__ + "files/SPIADI2025 - Rapport national OBSERVA4 - octobre 2026.9e6cce0b8c678bc4fd9e1273d36c86a2.pdf";